import React from 'react';

import { AuthContextProvider } from '@/context/auth';

import { useAuthProvider } from './useAuthProvider';

interface IAuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<IAuthProviderProps> = ({ children }) => {
  const auth = useAuthProvider();
  return <AuthContextProvider value={auth}>{children}</AuthContextProvider>;
};

export default AuthProvider;
